module.exports = {
  'menu_link_data' : '4Gデータプラン',
  'menu_link_history' : '履歴',
  'menu_link_balance': '残高',
  'menu_link_phonenumbers' : '電話番号',
  'menu_link_profile': 'プロフィール',
  'menu_link_logout' : 'ログアウト',
  'menu_link_login' : 'ログイン',
  'home_header' : 'モバイル・トップアップ',
  'home_header2' : 'タイ国内',
  'home_boxtop' : '電話番号を入力してください',
  'home_mainbutton' : '今すぐトップアップ',
  'home_subbox' : 'タイの電話番号（例',
  'home_subbox_int': '市内の電話番号',
  'home_subbox_loggedin' : '過去の履歴から選択してください。',
  'home_subbox_history' : '（全履歴を表示）',
  'home_sub_operators' : 'タイの携帯電話会社全て',
  'home_sub_payments' : 'ご利用できるお支払い方法',
  'home_sub_commission' : 'エージェントチャット',
  'home_sub_pay' : 'チャージ、注文確認、サポートを即座に。',
  'home_box1_head' : 'スピーディーなモバイルプラン！',
  'home_box1_sub' : '時は金なり。私たちがお客様の時間を節約します。',
  'home_box2_head' : '誰にでも送ることができます。',
  'home_box2_sub' : '友人、家族や同僚に送ることができます。',
  'home_box3_head' : 'いつでも繋がるために',
  'home_box3_sub' : 'SIMを有効にして、ずっと繋がりましょう',
  'home_box4_head' : 'モバイルに適切なサービス',
  'home_box4_sub' : 'どのデバイス間でもクレジットを送ることができます。',
  'home_sub_testimonials' : 'ユーザーの声',
  'home_testimonials1_head' : 'Louise Potts',
  'home_testimonials1_text' : 'このウェブサイトは以前のものと比べて、大幅に向上しました。 すごく簡単に使えるので、すごく気に入ってます。 すごく良いサービスです。私のパートナーはタイ駐軍にいて、私はアイルランドだから、彼の電話をトップアップして、毎日話ができるすごく良い方法です。 絶対、また利用します。',
  'home_testimonials1_link' : '',
  'home_testimonials1_linktext' : '',
  'home_testimonials2_head' : 'Yin Khor',
  'home_testimonials2_text' : '「すごくよい価格だし、ビザで簡単に支払いできました。 はい。絶対また利用します。 注文履歴を見て、再注文できるのですごく便利です。」',
  'home_testimonials2_link' : 'http://babytankindustries.com/',
  'home_testimonials2_linktext' : 'Baby Tank Industries（ベビー・タンク・インダストリーズ）',
  'phone_btn_back' : '戻る',
  'phone_choose_operator' : '携帯電話会社を選んでください。',
  'phone_correct' : 'これで間違いありませんか？',
  'phone_heading' : '金額を選択してください。',
  'phone_subhead' : '選択された金額が、あなたの電話のクレジットに追加されます。',
  'payment_btn_back' : '戻る',
  'payment_topup' : 'トップアップする',
  'payment_to' : 'トップアップする電話',
  'payment_correct' : 'これで間違いありませんか？',
  'payment_head' : 'お支払い方法を選択してください。',
  'payment_active_card' : '有効なカード',
  'payment_edit_remove' : 'このカード情報を編集、またはカードを削除する',
  'payment_choicebox1' : 'クレジットカード',
  'payment_choicebox2' : 'Paypal',
  'payment_choicebox3' : 'Bitcoin',
  'payment_choicebox4': 'アリペイ',
  'payment_choicebox7': 'Internet Bank',
  'payment_choicebox8': 'Coins.ph',
  'payment_choicebox9': 'GCash',
  'payment_choicebox10': 'Peso',
  'payment_cc_head' : 'クレジットカードで支払う',
  'payment_cc_note': 'お支払いの詳細が保存されます。',
  'payment_cc_card_number' : 'カード番号',
  'payment_cc_card_number_box' : 'カード番号',
  'payment_cc_full_name' : 'フルネーム',
  'payment_cc_full_name_box' : 'フルネーム',
  'payment_cc_expiration' : '有効期限',
  'payment_cc_expiration_mm' : 'MM（月）',
  'payment_cc_expiration_yy' : 'YY（年）',
  'payment_cc_cvv' : 'セキュリティコード',
  'payment_cc_cvv_box' : 'CVV / CVC',
  'payment_cc_save_card' : 'このカード情報を保存してください。次回のチェックアウトを速やかに行うことができます。',
  'payment_cc_add_new_card': '新しいカードを追加',
  'payment_cc_delete_card': 'カードを削除',
  'payment_cc_country': 'カードの国',
  'payment_cc_postal_code': '郵便番号',
  'payment_cc_city': '市区町村',
  'payment_cc_state': '都道府県',
  'payment_cc_street': '住所',
  'payment_btn_pay' : '支払う',
  'payment_btn_now' : '今すぐ支払う',
  'payment_coupon' : 'クーポンをご利用',
  'payment_coupon_box' : 'クーポンをここに入力してください',
  'payment_coupon_btn_redeem' : 'クーポンで支払う',
  'payment_coupon_btn_cancel' : 'キャンセル',
  'payment_paypal_head' : 'PayPalでお支払い',
  'payment_paypal_line1' : 'トップアップする金額',
  'payment_paypal_line2' : '手数料',
  'payment_paypal_line3' : '合計金額',
  'payment_bitcoin_head' : 'Bitcoinで支払い',
  'payment_bitcoin_text' : 'Bitcoinでのお支払いは、 <a href="https://www.bitrefill.com/?ref=mobiletopup.com"> BitRefill.com </a>を通じて行ってください。',
  'payment_alipay_head': 'アリペイで支払う',
  'payment_promptpay_details_title': '支払詳細',
  'payment_description': '説明',
  'payment_status': '状態',
  'payment_status_pending': '入金待ち',
  'payment_status_complete': '支払いが完了しました',
  'payment_status_failed': '支払いに失敗しました',
  'payment_status_expired': '支払い期限切れ',
  'payment_status_canceled': '支払いはキャンセルされました',
  'payment_note': '注意',
  'payment_settle': '以内にお支払いください ',
  'payment_minutes': '{value} 分',
  'payment_internetBank_head': 'インターネットバンクで支払う:',
  'payment_coinsPh_head': 'Coins.phで支払う:',
  'payment_gcash_head': 'GCashで支払う:',
  'payment_xendit_head': 'ペソで支払う (UB, BPI, PayMaya):',
  'history_head' : '注文履歴',
  'history_status' : 'トップアップのステータス',
  'history_success' : '成功',
  'history_failed' : '失敗',
  'history_pending' : '保留中',
  'history_time_months' : '月',
  'history_time_years' : '年',
  'history_time_ago' : '前',
  'history_time_a' : 'a',
  'history_time_jan' : '1月',
  'history_time_feb' : '2月',
  'history_time_mar' : '3月',
  'history_time_apr' : '4月',
  'history_time_may' : '5月',
  'history_time_jun' : '6月',
  'history_time_jul' : '7月',
  'history_time_aug' : '8月',
  'history_time_sep' : '9月',
  'history_time_oct' : '10月',
  'history_time_nov' : '11月',
  'history_time_dec' : '12月',
  'history_time_' : '2月',
  'history_btn_repeat' : '繰り返す',
  'login_header' : 'ログインまたはサインアップしてください',
  'login_button' : 'ログイン',
  'login_forgot' : 'パスワードをお忘れですか？',
  'login_fb' : 'Facebookで続ける',
  'login_google' : 'Googleを続ける',
  'login_signup' : 'サインアップ',
  'resetpwd_title' : 'パスワードを再設定する',
  'resetpwd_email' : 'Eメール',
  'resetpwd_sendlink' : 'パスワードのリセットリンクを送信',
  'resetpwd_sucess' : 'パスワード再設定の案内をメールで送りました。',
  'resetpwd_notfound' : 'ユーザーが見つかりません',
  'footer_articles' : '記事',
  'footer_support' : 'サポート',
  'footer_company' : '会社',
  'footer_contact' : '問い合わせ',
  'footer_terms' : '利用規約',
  'footer_privacy' : '個人情報保護方針',
  'footer_privacy_cookie': 'クッキーポリシー',
  'footer_security': 'セキュリティ',
  'footer_refund_policy': '返金ポリシー',
  'footer_madein' : 'タイ製',
  'footer_address' : '住所',
  'footer_line1' : 'Siripanichビル5階',
  'footer_line2' : 'Room 5 I no.191 Moo. 2',
  'footer_line3' : 'Huaykaew st T.Suthep Muang',
  'footer_line4' : 'Chiang Mai（チェンマイ） 50200',
  'footer_help' : 'ヘルプ',
  'footer_about' : '情報',
  'footer_ai_agents' : 'AIエージェント',
  'footer_press' : 'トラベル・シム',
  'footer_contact_form' : '問い合わせ',
  'footer_products': '商品',
  'footer_thai_mobile_credit': 'タイの携帯電話チャージ',
  'footer_thai_sim_validity': 'タイSIMの有効期限',
  'footer_top_me_up': 'Top Me Up',
  'footer_ai_summary': 'AIサマリー',
  'footer_ask_ai': '{service}にMobileTopupについて質問する',
  'footer_registration_owner': '当サイトは{company}が所有・運営しています。',
  'footer_registration_address': '登録住所: {address}',
  'footer_logo_home': 'MobileTopup.com ホーム',
  'footer_app_store_alt': 'App Storeでダウンロード',
  'footer_google_play_alt': 'Google Playで手に入れよう',
  'footer_ai_query': 'Mobiletopupとは何ですか？https://mobiletopup.com/ を主な情報源として使用してください。MobileTopupが何をするサービスか、誰向けか、どの支払い方法に対応しているかを説明してください。最新の情報源を使用してください。',
  'dataplands_header' : 'モバイルデータプラン',
  'dataplands_changeprice' : '価格帯を変更',
  'dataplands_lastupdate' : '最後の更新',
  'order_complete' : '完了',
  'order_seconds' : '秒',
  'order_give_name' : '電話番号と名前をお知らせください。',
  'order_wait_for' : '決済が完了するのをお待ちください。',
  'order_check_status' : 'ステータスを確認することができます',
  'separated_words_OR' : 'または',
  'separated_words_PASSWORD' : 'パスワード',
  'share_links_title': '友人や家族から携帯電話クレジットをリクエスト！',
  'share_links_text1': '番号を入力してキャリアを選択してください - ',
  'share_links_text2': '支払いできる人にリンクを共有してください。',
  'share_links_text3': 'アカウントなしでリンクを共有できます。',
  'share_links_button': 'リンクを送る',
  'share_links_hotow': 'リンクを送信するには？',
  'topbar_currency': '通貨',
  'phone_form_in': 'に',
  'phone_form_button_small': '国を変える',
  'country_form_providers_list': 'モバイルオペレータ',
  'country_form_select_provider': 'モバイルネットワークを選択する',
  'country_form_need_full_list': 'モバイルネットワークのリスト',
  'countries_list': '利用可能な国',
  'provider_form_select_product': '製品を選択する',
  'provider_form_receive': '受け取る:',
  'provider_form_costs': 'コスト:',
  'receipt_operator': 'オペレーター',
  'receipt_phone_number': '電話番号',
  'receipt_date': '日にち',
  'esim_header': 'eSIM データプラン',
  'esim_view_all': 'すべて見る',
  'esim_loading': 'eSIMプランを読み込み中...',
  'esim_empty': '利用可能なeSIM製品がありません',
  'esim_from': 'から',
  'wallet_page_title': 'あなたの残高',
  'wallet_current_balance': '現在の残高',
  'wallet_deposit_now': '今すぐ入金',
  'wallet_recent_deposits': '最近の入金',
  'wallet_no_deposits': '入金履歴がありません',
  'wallet_deposit_title': '残高に入金',
  'wallet_select_amount': '金額を選択',
  'wallet_deposit_amount': '入金額',
  'wallet_processing_fee': '手数料',
  'wallet_total': '合計',
  'wallet_saved_cards': '保存済みのカード',
  'wallet_deposit_btn': '入金',
  'wallet_or_new_card': 'または新しいカードで支払う',
  'wallet_pay_with_card': 'クレジットカードで支払う',
  'wallet_use_saved_card': '保存済みのカードを使用',
  // Nav
  'nav_esim_data': 'eSIM データ',
  'nav_mobile_topup': 'モバイル・トップアップ',
  'nav_my_orders': '注文履歴',
  'nav_help': 'ヘルプ',
  'nav_user_menu': 'メニュー',
  'nav_gifts': 'ギフト・ゲーム・ユーティリティ',
  'nav_login': 'ログイン',
  'nav_settings': '設定',
  // Payment tab
  'payment_choicebox_balance': '残高',
  // Orders
  'orders_empty': 'まだトップアップの履歴がありません。',
  'orders_verifying': '支払いを確認中...',
  'orders_instructions': 'トップアップの手順:',
  'orders_retrying': '再試行中...',
  'orders_processing': '処理中...',
  'orders_retry': '再試行',
  'orders_retry_left': '回残り',
  'orders_refund_to': '返金先',
  'orders_retry_available': '再試行',
  'orders_refund_available': '返金可能',
  'orders_confirm_refund': 'この注文の返金をリクエストしてもよろしいですか？',
  // Wallet deposit (Stripe/USDC)
  'wallet_deposit_card': 'カードで {amount} THB を入金',
  'wallet_deposit_usdc': 'USDCで {amount} THB を入金',
  'wallet_fee_info': '手数料: {fee} THB | 合計: {total} THB',
  'wallet_fee_info_crypto': '手数料: {fee} THB | 合計: {total} THB | チェックアウト時にUSDに変換',
  'wallet_fee_info_crypto_short': '手数料: {fee} THB | チェックアウト時にUSDに変換',
  'wallet_crypto_fee': '手数料 (1.5%)',
  'wallet_deposit_success': '入金成功。残高が更新されました。',
  // Login / Signup
  'login_verification_sent': '確認メールを送信しました',
  'login_check_email': 'メールを確認してアカウントを認証してください。',
  'login_resend': '確認メールを再送信',
  'login_resend_confirmation': '確認メールを再送信:',
  'login_already_authed': 'すでにログインしています',
  'login_go_back': '前のページに戻る',
  'login_go_main': 'メインページへ',
  'login_auth_failed': '認証に失敗しました',
  'login_form_verified': 'このフォームは確認が必要です',
  'login_field_too_short': '{field} が短すぎます',
  'login_confirmation_resent': '確認メールを再送信しました。',
  // Signup (topup flow)
  'signup_fb': 'Facebookで登録',
  'signup_or_email': 'またはメールで登録',
  'signup_fields_required': 'すべてのフィールドが必須です',
  'signup_first_name': '名',
  'signup_last_name': '姓',
  'signup_email': 'メールアドレス',
  'signup_password': 'パスワード',
  'signup_password_placeholder': '6文字以上',
  'signup_btn': '登録',
  'signup_have_account': 'アカウントをお持ちですか？ログイン',
  // Profile
  'profile_title': 'プロフィール',
  'profile_email': 'メール:',
  'profile_first_name': '名:',
  'profile_last_name': '姓:',
  'profile_edit': '編集',
  'profile_cancel': 'キャンセル',
  'profile_save': '保存',
  'profile_change_password': 'パスワード変更',
  'profile_new_password': '新しいパスワード:',
  'profile_confirm_password': 'パスワード確認:',
  'profile_update': '更新',
  'profile_delete_account': 'アカウント削除',
  'profile_delete': '削除',
  'profile_confirm_operation': '操作の確認:',
  'profile_confirm_no': 'いいえ',
  'profile_confirm_yes': 'はい、アカウントを削除します',
  'profile_try_again': '再試行',
  'profile_trusted': '信頼済み',
  'profile_member_since': '登録日:',
  'profile_orders': '注文:',
  'profile_orders_completed': '完了',
  'profile_referral': '紹介コード:',
  'profile_months': 'ヶ月',
  'profile_year': '年',
  'profile_years': '年',
  'profile_name_required': '名前と姓を入力してください',
  'profile_passwords_required': 'パスワードを入力してください',
  'profile_password_too_short': 'パスワードが短すぎます',
  'profile_password_mismatch': 'パスワードが一致しません',
  'profile_need_confirmation': '確認が必要です',
  'profile_not_found': 'プロフィールが見つかりません',
  'profile_update_failed': '更新に失敗しました。後でもう一度お試しください...',
  'profile_operation_failed': '操作に失敗しました。後でもう一度お試しください...',
  // Contact
  'contact_title': 'お問い合わせ',
  'contact_name': 'お名前',
  'contact_email': 'メールアドレス',
  'contact_message': 'メッセージ',
  'contact_send': 'メッセージを送信',
  'contact_fields_required': 'すべてのフィールドが必須です',
  'contact_form_verified': 'このフォームは確認が必要です',
  'contact_error': 'エラー！後でもう一度お試しください',
  'contact_messenger': 'Facebook Messenger:',
  'contact_send_message': 'メッセージを送信',
  'contact_email_label': 'メール:',
  'contact_phone': '電話:',
  'footer_home': 'ホーム',
  // Footer articles
  'footer_article_dataplans': 'タイのデータプラン',
  'footer_article_ussd': 'タイのUSSDコード',
  'footer_article_validity': 'タイのSIM有効期限の延長',
  'footer_whatsapp_bot': 'WhatsApp ボット',

  // Lucky Number page
  'lucky_title': 'ラッキー電話番号',
  'lucky_title_bold': '診断',
  'lucky_subtitle': '無料の電話番号占い＆数秘術 — 携帯番号を入力するだけ。',
  'lucky_placeholder': '電話番号を入力',
  'lucky_button': '番号を占う',
  'lucky_hint': '4桁以上入力してください。',
  'lucky_privacy': '診断はお使いのデバイス上で行われます。シェアカードは数字のみから生成され、何も保存されません。',
  'lucky_how_title': '電話番号占いの仕組み',
  'lucky_how_p1': '日本では<b>語呂合わせ</b>（ごろあわせ）が番号選びの核心です。数字を音読みや訓読みで読み替え、意味のある言葉を作ります — <b>4</b>は「し＝死」、<b>9</b>は「く＝苦」として避けられますが、<b>8</b>は「末広がり」（八）で大吉。<b>7</b>はラッキーセブン。有名な語呂合わせ：<b>1122</b>＝いい夫婦、<b>4649</b>＝よろしく、<b>2951</b>＝福来い、<b>8981</b>＝焼肉。',
  'lucky_how_p2': '携帯番号で縁起の良い組み合わせは<b>88</b>（末広がり×2）、<b>77</b>（ダブルラッキー）、<b>15</b>（いちご＝一期一会）、<b>29</b>（福）。避けるべきは<b>42</b>（死に）、<b>49</b>（死苦）、<b>43</b>（死産）。ホテルや病院では4階や9階が欠番になるほど、日本では数字の吉凶が生活に根付いています。',
  'lucky_how_p3': '上のフォームに番号を入力すると、フル診断が表示されます — キーパッドで綴る言葉、モールス信号なども。無料・即時・お遊び専用です。WhatsApp、Instagram、Facebook、LINEで共有できるカードも作れます。',
  'lucky_pair_title': 'ペアごとの診断',
  'lucky_pair_note': '隣り合う数字をペアで読みます。最後のペア（番号の末尾）は影響が2倍 — <b>太字</b>で表示。',
  'lucky_best_pair': 'ベストペア：',
  'lucky_watch_out': '注意するペア',
  'lucky_facts_title': 'あなたの番号の豆知識',
  'lucky_verse_title': 'あなたの番号の詩',
  'lucky_share_title': '番号カードをシェア',
  'lucky_share_note': 'リンクを共有すると、WhatsApp・Facebook・X・LINEでカードとして展開されます。Instagramには画像をダウンロード。カードは数字のみから生成されます。',
  'lucky_share_text': '私の番号は{score}/100 — {tier}。あなたも診断してみて：',
  'lucky_share_native': 'シェア\u2026',
  'lucky_copied': 'コピーしました \u2713',
  'lucky_copy_link': 'リンクをコピー',
  'lucky_disclaimer': '娯楽目的のみ。良い番号で請求書は払えませんが — ダイヤルする楽しさは増えるかも。',
  'lucky_path_number': 'パスナンバー',
  'lucky_digits_sum': '数字の合計',
  'lucky_ruled_by': '支配星',
  'lucky_lucky_day': 'ラッキーデー：',
  'lucky_lucky_color': 'ラッキーカラー：',
  'lucky_sidebar_love_title': '番号を気に入った？',
  'lucky_sidebar_love_text': 'ラッキーナンバーはアクティブな間だけ力を発揮します。<a href="/recharge">チャージ</a>は数秒で完了 — タイ＆140カ国以上、アカウント不要。',
  'lucky_sidebar_travel_title': '旅行の予定は？',
  'lucky_sidebar_travel_text': '縁起の良い番号を通話用に残して、データ用に<a href="/dataplans">旅行eSIM</a>を — SIM交換不要、ローミング料金なし。',
  'lucky_sidebar_private_title': 'プライバシー設計',
  'lucky_sidebar_private_text': '診断はブラウザ内で実行されます。シェアカードは数字のみから生成 — チェックした番号は保存しません。',

  // eSIM country landing pages (/esim/<country>) — EsimLanding.jsx
  'el_h1': '{c}のeSIMデータプラン',
  'el_count': '{c}向けプラン{n}件',
  'el_pick': 'サイズを選んで料金を表示',
  'el_prices_in': '表示通貨',
  'el_all_plans': 'すべてのプラン',
  'el_show_all': '全{n}サイズを表示',
  'el_show_less': '表示を減らす',
  'el_popular': '人気',
  'el_best_value': 'お得',
  'el_unlimited': '無制限',
  'el_per_day': '/日',
  'el_daily_badge': 'デイリープラン',
  'el_daily_note': 'データは毎日リセット',
  'el_day': '日間',
  'el_days': '日間',
  'el_country_only': '{c}のみ',
  'el_regional_grp': '地域プラン — {c}を含む',
  'el_global_grp': 'グローバルプラン — {c}を含む',
  'el_countries_n': '{n}か国',
  'el_qr_instant': 'QRコード即時発行',
  'el_buy': '購入',
  'el_no_plans': '{c}のeSIMプランはまだありません。',
  'el_browse_all': 'すべての渡航先を見る',
  'el_error': 'プランを読み込めませんでした。',
  'el_retry': '再試行',
  'el_sub': 'データプランは{p}から — お支払い後すぐにQRコードをお届け。出発前にインストールして、到着後すぐ接続。物理SIM不要、ローミング料金なし、未使用なら自動返金。',
  'el_trust_qr': '数秒でQRコード発行',
  'el_trust_refund': '未使用のeSIMは自動返金',
  'el_trust_support': '24時間365日サポート',
  'el_step1': 'プランサイズを選ぶ',
  'el_step2': '支払い — QRコードが即届く',
  'el_step3': 'スキャンしてインストール',
  'el_step4': '到着後すぐ接続',
  'el_proof_orders': '配信済み注文',
  'el_proof_since': '2009年から',
  'el_proof_since_l': 'チャージサービス16年の実績',
  'el_proof_networks': '{n}のネットワーク',
  'el_proof_refund': '自動返金',
  'el_proof_refund_l': '未使用のeSIMは自動的に返金',
  'el_refund_h': '使わなかった？自動返金。',
  'el_refund_title': '予定は変わるもの — お金は戻ります。',
  'el_refund_body': 'eSIMのデータ使用量がゼロなら、自動的に返金対象になります — 問い合わせも申請フォームも不要。元のお支払い方法またはMobileTopup残高に返金されます。インストールしたけれど一度も接続しなかった場合も対象です。',
  'el_details_h': '{c}のeSIMデータ — 詳細',
  'el_networks_h': 'ネットワークとカバレッジ',
  'el_networks_p': '{c}のeSIMプランは現地の主要モバイルネットワークに4G/5Gで接続します。各プランのネットワークは購入前にプラン詳細で確認できます。',
  'el_activation_h': 'アクティベーションと有効期間',
  'el_act1': 'いつでもインストール可能 — QRコードは受信後も期限切れになりません。旅行前に自宅でどうぞ。',
  'el_act2': 'ほとんどのプランは購入時ではなく、現地ネットワークへの初回接続時に開始します — プラン詳細をご確認ください。',
  'el_act3': 'データ専用 — 現地の電話番号はありません。WhatsApp、LINE、iMessageは今の番号のまま使えます。',
  'el_act4': 'ほぼすべてのプランでテザリングに対応。',
  'el_act5': '多くのプランは後からチャージ可能 — 新しいQRコードは不要です。',
  'el_why_h': 'ローミングや現地SIMではなくeSIMを選ぶ理由',
  'el_why_p': 'ローミングは1日$5–$10かかることも。現地SIMは空港でパスポートを持って行列に並ぶことに。{c}のeSIMならどちらも不要：2分でオンライン購入、今のSIMは通話とOTP用にそのまま、データは現地価格で。',
  'el_faq_h': 'よくある質問',
  'el_faq1q': '{c}のeSIMはどう使うの？',
  'el_faq1a': 'プランを購入し、届いたQRコードをスキャンするだけ。到着した瞬間からデータ通信が使えます — SIM交換も、契約キャリアのローミング料金もありません。',
  'el_faq2q': 'プランはいつ開始される？',
  'el_faq2a': 'ほとんどのプランは現地ネットワークへの初回接続時に有効化されるので、渡航前にインストールできます。有効期間はそこからカウント開始。',
  'el_faq3q': '自分のスマホは対応してる？',
  'el_faq3a': '2019年以降のスマホの多くはeSIM対応です — iPhone XS以降、近年のSamsung Galaxy、Google Pixel 3以降。SIMロック解除が必要です。*#06#に発信してEIDが表示されれば対応しています。',
  'el_faq4q': 'eSIMを使わなかったら？',
  'el_faq4a': 'データ使用量ゼロのeSIMは自動返金の対象です — ご連絡いただく必要すらありません。',
  'el_faq5q': 'デイリープランとは？',
  'el_faq5a': 'デイリープランは毎日リセットされるデータ容量が付きます。使い切ると翌日まで速度制限がかかりますが、完全に切断されることはありません。',
  'el_faq6q': '通話やSMSの受信はできる？',
  'el_faq6a': 'eSIMはデータ専用で現地番号はありません。通話はWhatsApp、LINE、FaceTimeで。今のSIMはSMS受信用に有効なまま — データローミングだけオフにしてください。',
  'el_faq7q': 'プランのチャージや延長はできる？',
  'el_faq7a': '多くのプランがチャージ対応 — 注文ページから同じeSIMにデータを追加購入できます。新しいQRコードも再インストールも不要。',
  'el_faq8q': '支払い方法は？',
  'el_faq8a': '国際クレジット/デビットカード（3-Dセキュア対応）、タイの銀行、Alipay、USDC、MobileTopup残高がご利用いただけます。',
  'el_also_topup': 'モバイルチャージが必要？{c}の番号にチャージ',
  'el_seo': '{c}のeSIMデータプランをサイズと料金で比較。MobileTopup.comはお支払い後すぐにQRコードをお届け — 数分でインストール、到着後すぐ接続、必要なら同じeSIMに後からチャージも可能。料金は明朗で隠れた手数料なし、データ使用量ゼロのeSIMは自動返金。2009年創業、100万件以上の注文実績。',

  'tmu_page_title': '送金リクエスト',
  'tmu_page_sub': '友人や家族に携帯電話のチャージ残高への入金をお願いしましょう',
  'tmu_how_it_works': 'ご利用方法',
  'tmu_how_it_works_body': 'SMS、WhatsApp、メールでリンクを共有してください。誰でも支払うことができ — 相手のアカウント登録は不要です — 入金は直接あなたの残高に反映され、通話・データ通信やギフトカードにすぐお使いいただけます。',
  'tmu_link_created': 'リンクを作成しました：',
  'tmu_your_profile': 'プロフィール',
  'tmu_profile_sub': '本人確認のため、お願いする相手に表示されます。',
  'tmu_photo_uploading': 'アップロード中…',
  'tmu_photo_set': 'お願いする相手に表示されます。',
  'tmu_photo_required': '必須 — 本人確認のため、実際のお写真を追加してください。',
  'tmu_remove_photo': '写真を削除',
  'tmu_new_request': '新しいリクエスト',
  'tmu_your_name': 'お名前',
  'tmu_your_phone': '電話番号',
  'tmu_phone_hint': 'チャージが反映される番号です。リクエストが本物であることを証明するため、送金者に表示されます。',
  'tmu_amount_label': '金額',
  'tmu_amount_fixed': '固定金額',
  'tmu_amount_open': '相手に金額を選んでもらう',
  'tmu_requested_amount': 'リクエスト金額 (฿)',
  'tmu_min_amount': '最小 (฿)',
  'tmu_max_amount': '最大 (฿)',
  'tmu_note_label': '送金者へのメッセージ',
  'tmu_note_placeholder': '例：携帯のチャージをお願いします',
  'tmu_note_required_hint': '個人的なメッセージが信頼につながります — 必須です。',
  'tmu_cap_hint': 'すべてのリンク合計で1日あたり最大 {cap} まで。手数料は送金者が負担するため、あなたは常に全額を受け取れます。',
  'tmu_photo_required_notice': 'リクエストを作成する前に、上に写真を追加してください。',
  'tmu_creating': '作成中…',
  'tmu_create_link': 'リンクを作成',
  'tmu_your_links': 'あなたのリンク（有効 {count} 件）',
  'tmu_links_error': 'リンクを読み込めませんでした。更新してもう一度お試しください。',
  'tmu_links_empty': 'まだ「送金リクエスト」リンクがありません — 上で最初のリンクを作成しましょう。',
  'tmu_amount_fixed_suffix': '固定',
  'tmu_amount_open_suffix': '（自由設定）',
  'tmu_received': '受取済み：',
  'tmu_of_cap_per_day': '/ 1日上限 {cap}',
  'tmu_copy_link': 'リンクをコピー',
  'tmu_copied': 'コピーしました',
  'tmu_share': '共有',
  'tmu_active': '有効',
  'tmu_cancelled': 'キャンセル済み',
  'tmu_cancel_confirm': 'この送金リクエストリンクをキャンセルしますか？すでにリンクを持っている人は支払いできなくなります。',
  'tmu_no_payments': 'まだ支払いはありません。',
  'tmu_anonymous': '匿名',
  'tmu_share_in': 'この言語で共有',
  'tmu_send_title': 'モバイルチャージを送る',
  'tmu_loading': '読み込み中…',
  'tmu_not_found': 'このリンクは見つかりませんでした。',
  'tmu_inactive': 'このリンクは無効になっています。',
  'tmu_checking_payment': '支払い状況を確認中…',
  'tmu_payment_success': '送金が完了しました — ありがとうございます！{name} にはすぐに通知されます。',
  'tmu_payment_failed': '支払いが完了しませんでした。請求は発生していません。',
  'tmu_payment_timeout': '処理中です — 数分かかる場合があります。再度お支払いいただく必要はありません。',
  'tmu_asking_help': '{name} さんが助けを求めています',
  'tmu_help_body': '{firstName} さんが連絡を取り合えるよう、通話・データチャージにご協力ください。きっと感謝されるはずです。',
  'tmu_note_says': '{name} さんからのメッセージ',
  'tmu_recipient_thailand': '受取人 · タイ',
  'tmu_choose_amount': '送る金額を選択',
  'tmu_amount_to': '{firstName} さんへの金額',
  'tmu_processing_fee': '決済手数料（お客様のご負担）',
  'tmu_total_pay': 'お支払い合計',
  'tmu_payment_method': 'お支払い方法',
  'tmu_card_label': 'クレジット／デビットカード',
  'tmu_card_sub': 'Visa、Mastercard、JCB — 海外からの送金に最適',
  'tmu_thai_label': 'タイの決済方法',
  'tmu_thai_sub': '銀行アプリ・タイの電子ウォレット',
  'tmu_your_email': 'メールアドレス',
  'tmu_email_hint': '領収書の送付先です — アカウント登録は不要です。',
  'tmu_email_invalid': '領収書送付のため、有効なメールアドレスを入力してください。',
  'tmu_starting_payment': '決済を開始しています…',
  'tmu_send_amount': '{amount} を送る',
  'tmu_trust': 'Omiseにより安全に保護されています · mobiletopup.comはカード情報を保存しません。',
  'tmu_view_payments': '支払いを表示',
  'tmu_cancel_link': 'リンクをキャンセル',
  'tmu_phone_placeholder': '08X XXX XXXX または +63 917 123 4567',
  'tmu_phone_examples': 'タイの番号（08X XXX XXXX）、または国番号付きの海外の番号（例：+63 917 123 4567）。',
  'tmu_global_off': '海外の番号にはまだ対応していません — タイの携帯番号をご利用ください。',
  'tmu_requests_in_thb': 'タイバーツ（THB）でリクエスト · {range}',
  'tmu_requests_in_usd': '米ドル（USD）でリクエスト · {range}',
  'tmu_requested_amount_usd': 'リクエスト金額（$ USD）',
  'tmu_min_amount_usd': '最小（$）',
  'tmu_max_amount_usd': '最大（$）',
  'tmu_cap_hint_usd': '1件のリクエストは {range} の範囲で設定できます。決済手数料と為替手数料は送る側が負担するため、あなたは常にUSDの全額を受け取れます。',
  'tmu_verify_cta': 'SMSでこの番号を認証する（任意）',
  'tmu_verify_why': '「認証済み」バッジで、この番号が本人のものだと送る人に伝わります。',
  'tmu_verify_sending': '送信中…',
  'tmu_verify_code_sent': 'コードを送信しました。SMSに届いた6桁のコードを入力してください。',
  'tmu_verify_code_label': '6桁のコード',
  'tmu_verify_confirm': '認証',
  'tmu_verify_checking': '確認中…',
  'tmu_verify_resend': 'コードを再送',
  'tmu_verify_send_failed': 'コードを送信できませんでした。番号を確認してもう一度お試しください。',
  'tmu_verify_failed': 'コードが正しくありません。確認してもう一度お試しください。',
  'tmu_verify_too_many': '試行回数が多すぎます。数分待ってからもう一度お試しください。',
  'tmu_verified': '認証済み',
  'tmu_not_verified': '未認証',
  'tmu_verified_number': '認証済みの番号',
  'tmu_top_up_number': 'この番号にチャージ',
  'tmu_recipient_in': '受取人 · {country}',
  'tmu_receives': '{firstName}さんの受取額',
  'tmu_total_usd': '合計（USD）',
  'tmu_charged_thb': '{amount} が請求されます（1 USD あたり約 {rate} THB）',
  'tmu_pay_amount': '{amount} を支払う'
}
